module.exports = __webpack_public_path__ + "static/img/iphone-左1.ba0e9b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/assets/pc/index/dss/iphone-左1.png
// module id = pUtJ
// module chunks = 0 2